<template>
  <a href @click.prevent="exportExcel()" class="btn btn-round ml-4" v-translate>Exporter en xlsx</a>
</template>

<script>
import { noteLink } from '../util/index';
import cloneDeep from 'lodash.clonedeep';
import dayjs from 'dayjs';
import { TYPE_LABELS, STATUS_LABELS } from '../util/index';

export default {
  name: 'TextNotesExportButton',
  props: ['filteredList'],
  methods: {
    async exportExcel() {
      let artworks = cloneDeep(this.xlsxList);
      const { default: Excel } = await import(/* webpackChunkName: "exceljs" */ 'exceljs');

      var wb = new Excel.Workbook();
      var sheet = wb.addWorksheet('text_notes');

      const headers = artworks.reduce((acc, item) => {
        Object.keys(item).map((k) => {
          if (!/_id|medias|related|note_properties/.test(k)) {
            acc[k] = { header: k, key: k };
          }
        }, {});
        return acc;
      }, {});

      sheet.columns = [
        { header: 'ID', key: 'id' },
        { header: 'Titrage', key: 'title', width: 40 },
        { header: 'Type de notice', key: 'type', width: 20 },
        { header: 'Rédacteur', key: 'author', width: 20 },
        { header: 'Dernière modification', key: 'updated_at', width: 10 },
        { header: 'Publiée', key: 'published', width: 10 },
        { header: 'Action en cours', key: 'status', width: 40 },
      ];

      artworks.map((a, index) => {
        a.id = {
          text: a.id,
          hyperlink: noteLink(a),
        };

        if (a.status === 'draft' && a.external) {
          a.status = 'draft_external';
        }
        a.updated_at = dayjs(a.updated_at).format('DD/MM/YYYY');
        a.type = TYPE_LABELS[a.type];
        a.status = STATUS_LABELS[a.status];
        a.published = a.external_id ? 'oui' : '';
        sheet.addRow(Object.assign({}, a));
      });

      wb.xlsx
        .writeBuffer()
        .then((buffer) => {
          var blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          var fileName = 'text_notes_export.xlsx';

          var link = document.createElement('a');
          link.setAttribute('href', window.URL.createObjectURL(blob));
          link.setAttribute('download', fileName);
          link.setAttribute('target', '_blank');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((error) => {
          throw error;
        });
    },
  },
  computed: {
    xlsxList() {
      const toXLSX = cloneDeep(this.filteredList);

      return toXLSX.map((item) => {
        Object.keys(item.note_properties).map((k) => (item[k] = item.note_properties[k]));
        return item;
      });
    },
  },
};
</script>
